module.exports = __webpack_public_path__ + "img/1.0493341c.jpg";